'use client';

import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

import { extractFunnelType } from '@/models';

export const useFunnelType = () => {
  const pathname = usePathname();

  return useMemo(() => extractFunnelType(pathname), [pathname]);
};
